import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';
import type { Persona, Personas, PersonaSwitched } from '@/api/types';
import { useAuth } from '@/auth';

const PERSONAS = ['personas'] as const;

/** Test accounts only (PERSONA_SWITCH_EMAILS); everyone else gets `enabled: false`. */
export function usePersonas() {
  const { status } = useAuth();
  return useQuery({
    queryKey: PERSONAS,
    queryFn: () => api.get<Personas>('/me/personas'),
    enabled: status === 'authenticated',
    staleTime: 60_000,
  });
}

export function currentPersona(data: Personas | undefined): Persona | undefined {
  return data?.items.find((item) => item.current);
}

/**
 * Same host: the session now acts with the chosen roles, so every cached
 * answer is stale. Another host: go there, already signed in.
 */
export function useSwitchPersona() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (key: string) => api.post<PersonaSwitched>('/me/personas/switch', { key }),
    onSuccess: async (data) => {
      if (data.url) {
        window.location.assign(data.url);
        return;
      }
      await client.invalidateQueries();
    },
  });
}
